module.exports = __webpack_public_path__ + "static/media/reshark.ba8bb70e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/reshark.webp
// module id = 822
// module chunks = 0